import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiDeleteCardVendor, ApiDeleteEdc, ApiGetCardVendorList, ApiGetEdcBankList, ApiGetEdcList, ApiInsertCardVendor } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import SaveButton from "components/Button/SaveButton";
import { MainBodyCard, PagesTitle } from "components/Cards";

export default function CardVendor(){
    let navigate = useNavigate()

    const { data: cardVendorList, fetch: getCardVendorList } = useFetch(ApiGetCardVendorList)
    const { fetch: insertCardVendor } = useFetch(ApiInsertCardVendor)
    const { fetch: deleteCardVendor } = useFetch(ApiDeleteCardVendor)

    const [cardVendorName, setCardVandorName] = useState(EmptyString)
    const [filterCardVendorName, setFilterCardVendorName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    const [errorCardVendorName, setErrorCardVandorName] = useState(false)

    const filterCardVendorNameChange = (e) => {setFilterCardVendorName(e.target.value)}
    const cardVendorNameChange = (e) => {setCardVandorName(e.target.value)}
    const statusChange = (e) => {setStatus(e.value)}

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        fBindGrid(0)
    },[])

    // Function Api Call

    async function fInsertCardVendor(){
        await insertCardVendor({
            data: {
                cardVendorName: cardVendorName
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCardVendorList(index){
        let res

        await getCardVendorList({
            data: {
                cardVendorName: filterCardVendorName,
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteCardVendor(cardVendorId, status){
        await deleteCardVendor({
            data: {
                cardVendorId: cardVendorId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetCardVendorList(i).then((res) => {
            if (res !== null && typeof res !== 'undefined'){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}
    const searchBtnClick = () => {
        fBindGrid(0)
    }
    const editBtnClick = (edcId) => {
        navigate("/setting/edc/form?edcId=" + edcId + "&formType=Edit")
    }
    const saveBtnClick = () => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    fInsertCardVendor().then(() => {
                        fBindGrid(pageIndex)
                        setCardVandorName(EmptyString)
                    })
                }
            }
        })
    }
    const deleteBtnClick = (cardVendorId, status) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    fDeleteCardVendor(cardVendorId, status).then(() => {
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }

    return(
        <MainBodyCard>
            <PagesTitle title='Card Vendor' />

            <div className="mt-3 border p-4 bg-white">
                <div>
                    <span className="font-semibold text-xl">Add Vendor</span>
                    <hr />
                </div>
                <div className="flex flex-col gap-3 mt-5">
                    {/* Card Vendor Name */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Vendor Name</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={cardVendorName} onChange={cardVendorNameChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorCardVendorName ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Vendor Name is required!</span>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                </div>
            </div>
            

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-72">
                        <span>Vendor Name</span>
                        <input className="input" value={filterCardVendorName} onChange={filterCardVendorNameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-36">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Vendor Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {cardVendorList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.cardVendorName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick(data.cardVendorId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.cardVendorId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.cardVendorId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </MainBodyCard>
    )
}